import { DocumentsTypes } from "types";
import { useGetDocumentsTypes } from "shared-apis";

import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";

import { usePrintTemplatesState } from "../../../atoms/printTemplatesAtom";

import styles from "../styles.module.scss";

export const PrintTemplatesGroupList = (): JSX.Element => {
  const { printTemplatesState, setPrintTemplatesState } =
    usePrintTemplatesState();
  const { data: documentsTypes = [] } = useGetDocumentsTypes();

  const handleClick = (type: DocumentsTypes | null) => {
    setPrintTemplatesState((prev) => ({ ...prev, activeDocumentType: type }));
  };

  return (
    <div className={styles.container}>
      <Row
        onClick={() => handleClick(null)}
        isActive={printTemplatesState.activeDocumentType === null}
      >
        <Paragraph>Все</Paragraph>
      </Row>

      {documentsTypes?.map((type: DocumentsTypes) => (
        <Row
          key={type.operationid}
          onClick={() => handleClick(type)}
          isActive={
            printTemplatesState.activeDocumentType?.operationid ===
            type.operationid
          }
        >
          <Paragraph>{type.name}</Paragraph>
        </Row>
      ))}
    </div>
  );
};
